import { render, staticRenderFns } from "./InterventionsDataTable.vue?vue&type=template&id=2e456010&scoped=true"
import script from "./InterventionsDataTable.vue?vue&type=script&lang=js"
export * from "./InterventionsDataTable.vue?vue&type=script&lang=js"
import style0 from "./InterventionsDataTable.vue?vue&type=style&index=0&id=2e456010&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e456010",
  null
  
)

export default component.exports